import styled from 'styled-components';

export const ZoneContainer = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-rows: 40% 60%;
`;
export const RatingsContainer = styled.div`
  position: relative;
  width: 95%;
  display: grid;
  grid-template-columns: auto auto;
  grid-template-rows: 20% 20% 20% 20%;
  justify-self: center;
  grid-gap: 3px;
  column-gap: 40px;
`;
export const MapContainer = styled.div`
  width: 100%;
  max-width: 700px;
  height: 250px;
  overflow: hidden;
  border-radius: 8px;
  background-color: #f5f5f5;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 100%;
    min-width: 700px;
    height: 250px;
    object-fit: cover;
    object-position: center;
  }
`;

export const Rating = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
`;

export const RatingLabel = styled.span`
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #212632;
`;

export const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 10px;
`;
export const StarsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30%;
`;
